import { ReactNode, useCallback, useMemo } from "react";
import { Col, Modal, Row } from "antd";
import { getFormattedCurrency } from "../../../../../lib/currencyFormatter";
import dayjs from "dayjs";
import {
  DISBURSEMENTS_METHOD_TYPES_HISTORY,
  PAYEE_TYPES,
} from "../../../../../lib/constants";

type DisbursementModalProps = {
  disbursementRecord: any;
  accountRoleInfo: any;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const DisbursementModal = ({
  disbursementRecord,
  open,
  setOpen,
  accountRoleInfo,
}: DisbursementModalProps) => {
  const close = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const title: ReactNode = useMemo(
    () => (
      <Row justify="start" key="modal-title">
        <Col>
          <div className="text w-500">Disbursement Details</div>
        </Col>
      </Row>
    ),
    [],
  );

  return (
    <>
      <Modal
        title={title}
        open={open}
        onCancel={close}
        footer={null}
        width={"100%"}
        centered
        destroyOnClose
        className="bordered-modal disbursement-details-modal"
        wrapClassName="z-1000 position-fixed"
      >
        <Row className="justify-center w-100 overflow-y-hidden">
          <Row className="w-100 d-block">
            <p className="text-md title my-0">Amount</p>
            <p className="text w-500 mt-0">
              {getFormattedCurrency(disbursementRecord?.amount)}
            </p>
          </Row>
          <Row className="w-100 d-block">
            <p className="text-md title my-0">Disbursement Date</p>
            <p className="text-md mt-0">
              {dayjs(disbursementRecord?.date).format("MMMM D, YYYY")}
            </p>
          </Row>
          <Row className="w-100 d-block">
            <p className="text-md title my-0">Payee</p>
            <p className="text-md mt-0">{disbursementRecord?.payeeName}</p>
          </Row>
          <Row className="w-100 d-block">
            <p className="text-md title my-0">Payee Type</p>
            <p className="text-md mt-0">
              {PAYEE_TYPES.find(
                (type) => type.value === disbursementRecord?.type,
              )?.label ?? "Other"}
            </p>
          </Row>
          {accountRoleInfo.isSeller && (
            <>
              <Row className="w-100 d-block">
                <p className="text-md title my-0">Method</p>
                <p className="text-md mt-0">
                  {disbursementRecord?.aggregated ? "+" : ""}
                  {DISBURSEMENTS_METHOD_TYPES_HISTORY.find(
                    (type) => type.value === disbursementRecord?.method,
                  )?.label ?? "Other"}
                </p>
              </Row>
              {disbursementRecord?.method === 1 &&
                disbursementRecord?.checkNumber && (
                  <Row className="w-100 d-block">
                    <p className="text-md title my-0">Check#</p>
                    <p className="text-md mt-0">
                      {disbursementRecord?.checkNumber}
                    </p>
                  </Row>
                )}
            </>
          )}
          {disbursementRecord?.description && (
            <Row className="w-100 d-block mb-3">
              <p className="text-md title my-0">Description</p>
              <p className="text-md mt-0">{disbursementRecord?.description}</p>
            </Row>
          )}
        </Row>
      </Modal>
    </>
  );
};
